<template>
  <el-select
      v-model="selectedVal"
      @change="selectChanged"
      style="width: 100%; line-height: 37.5px"
      filterable
      remote
      :remote-method="debouncedSearch"
      size="large"
      :disabled="disabled"
      :placeholder="placeholder || this.$t('also.please select')"
      :loading="loadingFirstPage"
      clearable
  >
    <el-option
        v-for="option in options"
        :label="option['label']"
        :value="option['value']"
        :key="option.value"
        :disabled="option.disabled"
    ></el-option>
    <!-- 此处加载中的value可以随便设置，只要不与其他数据重复即可 -->
    <el-option
        v-if="hasMore && selectLoading"
        disabled
        :label="this.$t('base.loading')"
        value="-1"
    ></el-option>
  </el-select>
</template>
<script>

import _ from "lodash";
import {
  getInstancesList,
} from '@/service/index'
import i18n from "@/i18n";
export default {
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: i18n.global.t('also.SelectingTheEquipment')
    },
  },
  emits: ["selectChanged"],
  data() {
    return {
      selectedVal: null,
      options: [],
      hasMore: true,
      selectLoading: false,
      loadingFirstPage: false,
      searchParam: {
        product_type: "1",
        page: 1,
        page_size: 10,
        keyword: ""
      },
      scrollWatched: false,
    };
  },
  mounted() {
    // 获取第一页
    this.getRelationInstancesList();
    if (!this.scrollWatched) {
      this.initScrollEventListener()
    }
  },
  methods: {
    selectChanged(value) {
      const item = this.options.find((item) => item.id == value);
      this.$emit("selectChanged", item);
    },
    initScrollEventListener() {
      this.$nextTick(() => {
        this.scrollWatched = true;
        // const SELECTWRAP = document.querySelector(
        //   ".el-select-dropdown .el-select-dropdown__wrap"
        // );
        const selectWraps = document.querySelectorAll(".el-select-dropdown .el-select-dropdown__wrap");
        const SELECTWRAP = selectWraps[selectWraps.length - 1];
        if (!SELECTWRAP) {
          throw new Error('无法找到 "el-select-dropdown__wrap" 节点');
        }
        SELECTWRAP.addEventListener("scroll", () => {
          // console.log('滚动了...')
          const CONDITION =
              SELECTWRAP.scrollHeight -
              Math.ceil(SELECTWRAP.scrollTop) <=
              SELECTWRAP.clientHeight + 50;
          if (CONDITION && SELECTWRAP.scrollTop !== 0) {
            // console.log('滚动到底部')
            this.loadMore()
          }
        });
      });
    },
    // 请求下一页的数据
    loadMore() {
      // 如果没有更多数据，则不请求
      if (!this.hasMore) {
        // console.log('没有更多数据了...')
        return;
      }
      if (this.selectLoading) {
        // console.log('正在请求中...')
        return;
      }
      this.searchParam.page++;
      this.getRelationInstancesList();
    },
    debouncedSearch: _.debounce(function (search) {
      this.searchChange(search)
    }, 500),
    searchChange(val) {
      // Check if the value is in options list
      const isOptionSelected = this.options.some((option) => option.label === val);
      if (isOptionSelected) {
        return;
      }

      // console.log('searchChange....', val)

      this.searchParam.keyword = val;
      this.searchParam.page = 1;
      this.getRelationInstancesList();
    },
    getRelationInstancesList() {
      // console.log('准备获取列表', this.searchParam)
      this.selectLoading = true;
      if (this.searchParam.page === 1) {
        this.loadingFirstPage = true;
      }
      getInstancesList(this.searchParam)
          .then((res) => {
            this.selectLoading = false;
            var inumList = JSON.parse(localStorage.getItem("inumList"));
            var isIndex = this.$route.query.layer_num;
            localStorage.setItem("layer_num", isIndex);
            var parId = localStorage.getItem("parId");
            if (res && res.payload && res.payload.data) {
              if (this.searchParam.page == 1) {
                this.options = res.payload.data;
                this.loadingFirstPage = false;
              } else {
                this.options = this.options.concat(res.payload.data);
              }
              if (this.options.length >= res.payload.count) {
                this.hasMore = false;
              } else {
                this.hasMore = true;
              }
              // console.log('结果获取到：', this.options.map((item) => {
              //   return {id:item.id, name:item.name, disabled: item.has_parent}
              // }))
              this.options.forEach((rel) => {
                rel.label = rel.name + "(" + rel.root_sn + ")"
                rel.value = rel.id;
                rel.disabled = rel.has_parent;
                if (parId == rel.id) {
                  rel.disabled = true;
                }
                //关联实例不能大于五层
                if (inumList && isIndex) {
                  inumList.map((item) => {
                    var nums = Number(item[rel.name]) + Number(isIndex);
                    if (item[rel.name] && Number(nums) > 5) {
                      rel.disabled = true;
                    }
                  });
                }
              });
              // 如果value有值，且options中没有该值，则添加到options中
              if (this.value && !this.options.some((item) => item.value == this.value)) {
                // console.log('添加到options中')
                this.options.push({
                  id: this.value,
                  label: this.placeholder,
                  value: this.value,
                  disabled: true
                })
              }

            }
          })
          .catch((error) => {
            console.log(error);
          });
    },
  }
}

</script>